// services/time-preference.service.js
import ApiService from './api.service';

const TimePreferenceService = {
  getPreference: () => 
    ApiService.fetch('time-preferences'),
  
  updatePreference: (data) => 
    ApiService.fetch('time-preferences', {
      method: 'PUT',
      body: JSON.stringify(data)
    })
};

export default TimePreferenceService;